import React from 'react';
import * as PropTypes from 'prop-types';
import { ToastContainer } from 'react-toastify';

import { COLORS } from '../../../constants/styles';
import { IconButton } from '../../Button/IconButton';

const CloseButton = ({ closeToast }) => (
  <IconButton onClick={closeToast} name="close" size={12} fill={COLORS.white} />
);

export const CustomToastsContainer = () => (
  <ToastContainer
    position="bottom-right"
    pauseOnVisibilityChange
    draggable
    closeButton={<CloseButton />}
  />
);

CloseButton.propTypes = {
  closeToast: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/components/common/CustomToastsContainer/index.jsx